<template>
  <div class="wh7html">
    <div class="wh7text">
      <div class="wh7header">
        <div class="headcon">
          <div style="display: inline-block; width: 0">
            <img
              src="https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=27"
              style="position: relative; top: 18px"
            />
          </div>
          <div class="router">
            <div class="rou">
              <router-link to="/aboveall">首页</router-link>
            </div>
            <ul class="rou listt" style="width: 80px">
              <router-link
                to="/proc/"
                active-class="seesee"
                >产品中心</router-link
              >
              <div class="listpro"  ref="first" style="width:140px">
                 <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/proc/productcenterjgyj/xwyb" active-class="nosee"
                    >价格研究</router-link
                  >
                </li>
                 <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/proc/productcenterzyjy/tljy" active-class="nosee"
                    >策略交易</router-link
                  >
                </li>
                 <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/proc/productcenterxgj/dzh" active-class="nosee"
                    >下单工具</router-link
                  >
                </li>
                 <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/proc/productcenterqtgn/qsxyj" active-class="nosee"
                    >其他特色功能</router-link
                  >
                </li>
                <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/proc/productcentersj" active-class="nosee"
                    >收费行情数据</router-link
                  >
                </li>
              </div>
            </ul>
            <!-- <div class="rou" style="margin-left: 20px">
              <router-link to="/download">下载</router-link>
            </div> -->
            <ul class="rou listt" style="margin-left: 20px; width: 33px">
              <router-link to="/download" active-class="seesee"
                >下载</router-link
              >
              <div class="listpro2">
                <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/download" active-class="nosee"
                    >实盘通用版</router-link
                  >
                </li>
                <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/download?id=false" active-class="nosee"
                    >体验版</router-link
                  >
                </li>
                <li
                  style="
                    width: 140px;
                    z-index: 108;
                    height: 35px;
                    line-height: 35px;
                    background: white;
                    padding-left: 20px;
                  "
                >
                  <router-link to="/download?id=mid" active-class="nosee"
                    >学习资料</router-link
                  >
                </li>
              </div>
            </ul>
            <div class="rou">
              <router-link to="/trade">交易通道</router-link>
            </div>
            <div class="rou"><router-link to="/buy/buy">购买</router-link></div>
            <div class="rou"><router-link to="/serive">服务</router-link></div>
            <div class="rou">
              <router-link to="/success">成功案例</router-link>
            </div>
            <div class="rou">
              <a href="https://www.wenhua.com.cn/" target="_blank">关于文华</a>
            </div>
          </div>
        </div>
      </div>
      <div class="excepthead">
        <div class="wh7body">
          <!-- <transition :name="transitionName" >
        </transition> -->
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showProduct: false,
      transitionName: "transitionLeft",
      ops: {
        vuescroll: {
          mode: "native",
          sizeStrategy: "number",
          detectResize: true,

          locking: false,
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: false,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: "right",
          maxHeight: undefined,
          maxWidth: undefined,
        },
        rail: {
          background: "#01a99a",
          opacity: 1,
          size: "6px",
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: "2px",
          keepShow: false,
        },
        bar: {
          showDelay: 2000,
          onlyShowBarOnScroll: true,
          keepShow: true,
          background: "#c1c1c1",
          opacity: 0,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: false,
          size: "6px",
          disable: false,
        },
      },
    };
  },
  directives: {
    portal: {
      //自定义指令用于外层渲染
      inserted: function (el, binding,vnode) {
        var value = binding.value;
        var app = document.querySelector("#app");
        try {
          vnode.context.setop(el)
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
      unbind: function (el) {
        try {
          el.parentNode.removeChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
  created(){
    // window.addEventListener('mousemove',this.listen);
    window.addEventListener('click',this.cli)
  },
  methods: {
    // listen(e){
    //   if (this.$refs.first.contains(e.target)||this.$refs.second1.contains(e.target)||this.$refs.second2.contains(e.target)){
    //       this.$refs.first.style.height=105+'px'
    //   }
    //   else{
    //     this.$refs.second1.style.display="none"
    //     this.$refs.second2.style.display="none"
    //     this.$refs.first.style.height=0+'px'
    //   }
    // },
    cli(){
      this.$refs.second1.style.display="none"
      this.$refs.second2.style.display="none"
      this.$refs.first.style.height=0+'px'
    },
    setop(el){
      this.resizes(el)
      window.addEventListener('resize',this.resizes(el))
    },
    resizes(el){
      var par=el.parentNode.getBoundingClientRect()
      console.log(par.top,par,el.parentNode,el)
      el.style.top=par.top+'px'
      el.style.left=par.right-45+'px'
    },
    showsecond(x){
      console.log('-------------------------',this.$refs["first"+x].getBoundingClientRect())
      var par=this.$refs["first"+x].getBoundingClientRect()
      var el =this.$refs["second"+x]
      console.log(par.top,par,el.parentNode,el)
      el.style.top=par.top+'px'
      el.style.left=par.right-45+'px'
      this.$refs.second1.style.display="none"
      this.$refs.second2.style.display="none"
      this.$refs["second"+x].style.display="block"
    },
    seeProduct() {
      this.showProduct = true;
    },
    hideProduct() {
      this.showProduct = false;
    },
    handleComplete() {
      console.log("scroll complete！");
    },
  },
  watch: {
    $route(to, from) {
      console.log(to)
      // const arr = [
      //   "/aboveall",
      //   "/proc/",
      //   "/proc/productcenter",
      //   "/proc/productcenter1",
      //   "/proc/productcenter2",
      //   "/download",
      //   "/trade",
      //   "/buy",
      //   "/serive",
      //   "/success",
      // ];
      // this.transitionName =
      //   arr.indexOf(to.path) > arr.indexOf(from.path)
      //     ? "transitionLeft"
      //     : "transitionRight";
    }, //路由轮播
  },
};
</script>

<style  scoped>
.wh7header {
  position: fixed;
  top: 0;
  height: 72px;
  line-height: 72px;
  width: 100%;
  background: white;
  filter: drop-shadow(0px 3px 5px #c2c5d4);
  z-index: 999;
}

.wh7footer {
  position: absolute;
  bottom: 0;
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 80px;

  margin: 0 auto;
  background-color: #14204a;
  color: #e8e9ed;
  font-size: 14px;
  line-height: 20px;
}
.wh7body {
  padding-top: 50px;
  width: 100%;
}
br {
  line-height: 0px;
}

.router {
  float: right;

  height: 70px;
}
.rou {
  margin-top: 5px;
  margin-left: 33px;
  z-index: 108;
  float: left;
  height: 30px;
}
a {
  text-decoration: none;
  color: #5c5c5c;
  display: inline-block;
  line-height: 27px;
  height: 27px;
  user-select: none;
}
.router-link-active {
  border-bottom: 3px solid #e3a200;
}
.headcon {
  width: 1000px;
  margin: 0 auto;
  /* padding-left: -webkit-calc(100vw - 100%);
  padding-left: calc(100vw - 100%); */
}
a:hover {
  color: #e3a200;
}
.nosee {
}
.seesee {
  border-bottom: 3px solid #e3a200;
}
.listpro {
  width: 115px;
  height: 0px;
  margin-top: -5px;
  background: white;
  overflow: hidden;
  transition: height 0.5s;
  -moz-transition: height 0.5s; /* Firefox 4 */
  -webkit-transition: height 0.5s; /* Safari and Chrome */
  -o-transition: height 0.5s; /* Opera */
}
.listt:hover .listpro {
  height: 175px !important;
}
.listpro2 {
  width: 125px;
  height: 0px;
  margin-top: -5px;
  background: white;
  overflow: hidden;
  transition: height 0.5s;
  -moz-transition: height 0.5s; /* Firefox 4 */
  -webkit-transition: height 0.5s; /* Safari and Chrome */
  -o-transition: height 0.5s; /* Opera */
}
.listt:hover .listpro2 {
  height: 105px;
}
/* .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
.transitionBody{
 transition: all 0.3s ;
 position: relative;
-webkit-transform: translate(0, 0);
  transform: translate(0, 0);


}
.transitionLeft-enter,
.transitionRight-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.transitionLeft-leave-active,
.transitionRight-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
  
}
.transitionLeft-enter-active,
.transitionRight-enter-active {  

position: absolute;
top: 50px;
left: 0;
right: 0;
bottom: 0;
} */

.wh7scroll {
  position: relative;
  min-height: 100%;
}
.wh7footer1 {
  position: absolute;
  top: 889px;
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 80px;

  margin: 0 auto;
  background-color: #14204a;
  color: #e8e9ed;
  font-size: 14px;
  line-height: 20px;
}
.wh7html {
  position: relative;
  min-height: 100%;
}
.first_nav{
  position: relative;
  cursor: pointer;
  color: #5c5c5c;
}
.first_nav span{
  height: 11px;
  width: 50px;
  display: inline-block;
  background: url(../assets/images/jt.svg) no-repeat top;
}
.second_nav .router-link-active{
  color:#e3a200;
  border-bottom: none;
}
.second_nav{
  position: fixed;
  display: none;
  filter: drop-shadow(0px 3px 5px #c2c5d4);
  z-index: 22222222222;
}
.first_nav:hover{
  color: #e3a200;
}
.first_nav:hover  {
  color: #e3a200;
}
.first_nav:hover span{
  background: url(../assets/images/jt1.svg) no-repeat top;
}
.second_nav li{
  width: 140px;
  z-index: 108;
  height: 35px;
  line-height: 35px;
  background: white;
  padding-left: 20px;
  list-style: none;
}
</style>
